module.exports = __webpack_public_path__ + "static/media/apply_client.fd766cf3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/apply_client.svg
// module id = 479
// module chunks = 0